import { getIntFromQuery, type PastaRoute, routePaginationHandler } from "@pasta/box-v2";
import AdminVersionsAnnouncement from "./admin-versions-announcement.vue";
import { type RouteLocationNormalized } from "vue-router";
import { useAuthStore } from "@pasta/front-auth-v2";

export const routes: PastaRoute[] = [
  {
    name: "version-announcements",
    path: "/admin-versions",
    component: AdminVersionsAnnouncement,
    props: (to: RouteLocationNormalized) => {
      return {
        ...routePaginationHandler(to),
        pageSize: getIntFromQuery(to.query.pageSize, 5),
      };
    },
    beforeEnter: [
      () => {
        if (useAuthStore().ability.cannot("create", "VersionAnnouncement")) {
          return { path: "/", name: "home" };
        }
      },
    ],
  },
];
